import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { getInitials } from 'helpers';
import { withRouter } from 'react-router';
import { redirectToRoute } from 'actions';
import _ from 'lodash';
import { bindActionCreators } from 'redux';
// import 'assets/fonts/material-icons/material-icons.scss';// TODO: consult with selva and remove this

const handleGoBack = (history) => {
  const currUrl = history.location.pathname;

  if (history.length < 2) {
    history.push('/dashboard');
  } else { history.goBack(); }

  setTimeout(() => {
    if (currUrl === history.location.pathname) {
      history.push('/dashboard');
    }
  }, 100);
};

const Header = ({ ...props }) => {
  const firstName = _.get(props, 'userprofile.memberFirstName', 'First');
  const lastName = _.get(props, 'userprofile.memberLastName', 'Last');

  const { headerTitle = 'Xome Pro', hasBackButton = false, hasNotificationIcon = true, backButtonIcon = 'back' } = props.header;
  const initials = getInitials(firstName, null, lastName) || 'Header Title';

  let backButtonClass = '';
  switch (backButtonIcon) {
    case 'close': case 'cancel':
      backButtonClass += ' icon-close';
      break;
    default:
      backButtonClass += ' icon-arrow-left';
  }

  const leftIconClass = hasBackButton ? backButtonClass : '';

  const noIcons = props.header.noIcons;

  const headerClassName = _.get(props, 'header.headerClassName', '');
  const positiveCount = (props.notificationsCount > 0);

  return <header id='header' className={headerClassName}>
    {
      !noIcons && (hasBackButton
        ? (
          <div className='icon-left'>
            <i className={leftIconClass} aria-hidden='true' onClick={() => handleGoBack(props.history)} />
          </div>
        )
        : <div className='name' onClick={() => props.redirectToRoute('/userprofile', { headerTitle: `${firstName} ${lastName}`, hasBackButton: true })}>{initials}</div>)
    }
    <h2>{headerTitle}</h2>
    {
      !noIcons && hasNotificationIcon && (
        <div className='notifications' onClick={() => props.redirectToRoute('/notifications', { headerTitle: 'Notifications', hasBackButton: false })}>
          { positiveCount &&
            <span className='nofication-badge'>{props.notificationsCount}</span>
          }
          <i className='icon-notifications' />
        </div>
      )
    }
  </header>;
};

Header.propTypes = {
  header: PropTypes.object.isRequired,
  userprofile: PropTypes.object.isRequired,
  notificationsCount: PropTypes.number.isRequired,
  history: PropTypes.object.isRequired,
  redirectToRoute: PropTypes.func.isRequired
};

const mapStateToProps = (state, ownProps) => ({
  header: state.header,
  notificationsCount: get(state, 'notifications.notificationsCount', 0),
  userprofile: state.userprofile,
  ...ownProps
});

const mapDispatchToProps = (dispatch) => ({
  redirectToRoute: bindActionCreators(redirectToRoute, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Header));
